var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.list_view)?_c('automation-list',{on:{"openAutomationCreate":_vm.openAutomationCreate}}):_c('automation-create',{attrs:{"automation_edit_detail":_vm.automation_edit_detail},on:{"openAutomationList":_vm.openAutomationList}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0671941b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/automation/AutomationDashboard.vue
// module id = null
// module chunks = 